'use client'
import { useRouter } from 'next/navigation'

import { EdsnText } from '@8percent/edsn-react'
import { EdsnIcon } from '@8percent/edsn-icons/react'

type Props = {
  title: string
}

export default function LogoHeader(props: Props) {
  const router = useRouter()

  const back = () => {
    router.back()
  }

  return (
    <div className="h-14 flex items-center">
      <div className="w-9 flex items-center justify-center cursor-pointer" onClick={back}>
        <EdsnIcon name="arrow-bold-left" size={18} />
      </div>
      <div>
        <EdsnText variant="heading-l-regular" as="span">
          {props.title}
        </EdsnText>
      </div>
    </div>
  )
}
